import { render, staticRenderFns } from "./delTips.vue?vue&type=template&id=3c06191a&scoped=true"
import script from "./delTips.vue?vue&type=script&lang=js"
export * from "./delTips.vue?vue&type=script&lang=js"
import style0 from "./delTips.vue?vue&type=style&index=0&id=3c06191a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06191a",
  null
  
)

export default component.exports